import type { LiveRegionProps } from './LiveRegion.types';

import React, { type ReactElement } from 'react';
import { View } from 'react-native';

export type { LiveRegionType, LiveRegionProps } from './LiveRegion.types';
export { LIVE_REGION_TYPES } from './LiveRegion.types';

/**
 * Web-specific live region that wraps children in a View with aria-live.
 *
 * react-native-web does not forward aria-atomic to the DOM, so we
 * apply it manually via a ref.
 *
 * @see https://experience.indeed.design/components/ids/live-region
 */
export const LiveRegion = ({
    children,
    type = 'polite',
    'aria-atomic': ariaAtomic,
}: LiveRegionProps): ReactElement => (
    <View aria-live={type} aria-atomic={ariaAtomic}>
        {children}
    </View>
);

LiveRegion.displayName = 'LiveRegion';
